export default __webpack_public_path__ + "static/media/KFOlCnqEu92Fr1MmWUlfBBc4AMP6lQ.a6d79156.woff2";